export default {
    type: {
        ViewShippingStatus: 'ViewShippingStatus', // '배송 조회 아웃링크'
        KakaoChatLink: 'KakaoChatLink', //카카오 상담톡으로 상담하기
        InterestedMemberSet: 'Interested Member', //관심회원 설정하러 가기
        ViewMoreSales: 'ViewMoreSales', //더 많은 매출내역 보기
        ChannelAtomyMedia: 'ChannelAtomyMedia', //채널 애터미 영상 보러가기
        ViewMoreBenefits: 'ViewMoreBenefits', //더 많은 수당내역 보기
        GeneralCommissionOther: 'GeneralCommissionOther', //타기간 후원수당 발생내역
        ViewMoreGeneralHistory: 'ViewMoreGeneralHistory', //더 많은 후원수당 발생내역 보기
        SeeMoreMastership: 'SeeMoreMastership', //더 많은 직급내역 보기
        ProductDetails: 'ProductDetails', //상품 상세정보
        ViewMoreOrders: 'ViewMoreOrders', //더 많은 주문내역 보기
        SeeMoreAnnoMember: 'SeeMoreAnnoMember', //더 많은 공지사항 보기 회원공지 탭
        SeeMoreAnnoSold: 'SeeMoreAnnoSold', //더 많은 공지사항 보기 품절/완판/재판매 공지 탭
        SeeMoreAnnoAlli: 'SeeMoreAnnoAlli', //더 많은 공지사항 보기 제휴서비스 공지 탭
        SeeMoreAnnoProduct: 'SeeMoreAnnoProduct', //더 많은 공지사항 보기 상품공지 탭
        EachSchedule: 'EachSchedule', //개별 스케쥴 건의 타이틀
        EachSeminar: 'EachSeminar', //개별 세미나 건의 타이틀 //seminarId필요
        ApplySeminar: 'ApplySeminar', //세미나 참가신청하기
        ChangeSaleDate: 'ChangeSaleDate', //판매일자 변경,
        BuyNow: 'BuyNow', //바로 구매하기
        OrderConfirm: 'OrderConfirm', //웹사이트로 주문조회 
    },  
    pc: {
        ViewShippingStatus: '배송 조회 아웃링크',    
        KakaoChatLink: 'https://accounts.kakao.com/login?continue=http%3A%2F%2Fpf.kakao.com%2F_xlSeid%2Fchat%3Fapi_ver%3D1.1%26kakao_agent%3Dsdk%252F1.39.16%2520os%252Fjavascript%2520sdk_type%252Fjavascript%2520lang%252Fko-KR%2520device%252FWin32%2520origin%252Fhttp%25253A%25252F%25252F{atomyDomain}%26app_key%3D6ed2bd89dca5c0c15bf67bf5952fb8fd%26referer%3Dhttp%253A%252F%252F{atomyDomain}%252Fkr%252Fm%252Fshop',
        InterestedMemberSet: '관심회원 설정하러 가기',
        ViewMoreSales: ' https://shop.atomy.com/kr/myoffice/mySales',
        ChannelAtomyMedia: 'https://ch.atomy.com/',
        // ViewMoreBenefits: 'https://{atomyDomain}/v2/Home/MyAtomy/MyBenefitList',
        // ViewMoreBenefits: ' https://shop.atomy.com/kr/myoffice/myExtraPay',
        ViewMoreBenefits: 'https://kr.atomy.com/myoffice/myAllow',
        // GeneralCommissionOther: 'https://{atomyDomain}/v2/Home/MyAtomy/SponsorBenefitOccurList',
        GeneralCommissionOther: 'https://kr.atomy.com/myoffice/myAllow/AllowSet',
        ViewMoreGeneralHistory: ' https://shop.atomy.com/kr/myoffice/myExtraPay/allowSet?currentTab=1',
        // SeeMoreMastership: 'https://{atomyDomain}/v2/Home/MyAtomy/PositionAllowance'
        SeeMoreMastership: 'https://kr.atomy.com/myoffice/myAllow/AllowSet',
        ProductDetails: 'https://shop.atomy.com/product/{Id}',
        ViewMoreOrders: '더 많은 주문내역 보기',
        SeeMoreAnnoMember: 'https://kr.atomy.com/cst/notice?largeCode=N01',
        // SeeMoreAnnoSold: 'https://shop.atomy.com/kr/customer/notice/list03?largeCode=N03',
        SeeMoreAnnoSold: 'https://kr.atomy.com/cst/notice?clssCd=40',
        SeeMoreAnnoAlli: ' https://kr.atomy.com/cst/notice?largeCode=N04',
        SeeMoreAnnoProduct: 'https://kr.atomy.com/cst/notice?largeCode=N02',
        EachSchedule: 'https://{atomyDomain}/v2/Home/MySchedule/MyScheduleList',
        EachSeminar: 'https://atomyticket.com/s/seminar/{SeminarId}?systemJisa=KR&systemLang=ko',
        ApplySeminar: 'https://atomyticket.com/h/main',
        ChangeSaleDate: ' https://shop.atomy.com/kr/mypage/order',
        BuyNow: 'https://kr.atomy.com/cart/view', // prod
        // BuyNow: 'https://qa-kr.atomyn.com/cart/view', // qa
        // BuyNow: 'https://dev-kr.atomyn.com/cart/view', // dev
        OrderConfirm: ' https://shop.atomy.com/kr/mypage/order', //웹사이트로 주문조회 
    },
    mobile: {
        ViewShippingStatus: '배송 조회 아웃링크',
        KakaoChatLink: 'https://accounts.kakao.com/login?continue=http%3A%2F%2Fpf.kakao.com%2F_xlSeid%2Fchat%3Fapi_ver%3D1.1%26kakao_agent%3Dsdk%252F1.39.16%2520os%252Fjavascript%2520sdk_type%252Fjavascript%2520lang%252Fko-KR%2520device%252FWin32%2520origin%252Fhttp%25253A%25252F%25252F{atomyDomain}%26app_key%3D6ed2bd89dca5c0c15bf67bf5952fb8fd%26referer%3Dhttp%253A%252F%252F{atomyDomain}%252Fkr%252Fm%252Fshop',
        InterestedMemberSet: 'http://{atomyDomain}/kr/m/office/tree/popup',
        ViewMoreSales: ' https://shop.atomy.com/kr/myoffice/mySales',
        ChannelAtomyMedia: 'https://ch.atomy.com/',
        // ViewMoreBenefits: 'http://{atomyDomain}/kr/m/office/benefit',
        // ViewMoreBenefits: ' https://shop.atomy.com/kr/myoffice/myExtraPay',
        ViewMoreBenefits: 'https://m-kr.atomy.com/myoffice/myAllow',
        // GeneralCommissionOther: 'http://{atomyDomain}/kr/m/office/benefit/sponsor',
        GeneralCommissionOther: 'https://m-kr.atomy.com/myoffice/myAllow/AllowSet',
        ViewMoreGeneralHistory: ' https://shop.atomy.com/kr/myoffice/myExtraPay/allowSet?currentTab=1',
        // SeeMoreMastership: 'http://{atomyDomain}/kr/m/office/benefit/mastership',
        SeeMoreMastership: 'https://m-kr.atomy.com/myoffice/myAllow/AllowSet',
        ProductDetails: 'http://m.atomy.com/kr/m/shop/products/{Id}/detail',
        ViewMoreOrders: '더 많은 주문내역 보기(모바일은 지원하지 않음)',
        SeeMoreAnnoMember: 'https://m-kr.atomy.com/cst/notice?largeCode=N01',
        // SeeMoreAnnoSold: 'http://{atomyDomain}/kr/m/helpdesk/notice?IsCommonGubun=false',
        SeeMoreAnnoSold: 'https://m-kr.atomy.com/cst/notice?clssCd=40',
        SeeMoreAnnoAlli: 'https://m-kr.atomy.com/cst/notice?largeCode=N04',
        SeeMoreAnnoProduct: 'https://m-kr.atomy.com/cst/notice?largeCode=N02',
        EachSchedule: 'http://{atomyDomain}/kr/m/office/schedule',
        EachSeminar: 'https://atomyticket.com/s/seminar/{SeminarId}?systemJisa=KR&systemLang=ko',
        ApplySeminar: 'https://atomyticket.com/h/main',
        ChangeSaleDate: ' https://shop.atomy.com/kr/mypage/order',
        BuyNow: 'https://kr.atomy.com/cart/view', // prod
        // BuyNow: 'https://qa-kr.atomyn.com/cart/view', // qa
        // BuyNow: 'https://dev-kr.atomyn.com/cart/view', // dev
        OrderConfirm: ' https://shop.atomy.com/kr/mypage/order', //웹사이트로 주문조회 

    }
};